import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SkeletonEventsComponent } from './skeleton-events.component';
import { SkeletonGridComponent } from './skeleton-grid.component';
import { SkeletonMarqueeComponent } from './skeleton-marquee.component';
import { SkeletonPage } from './skeleton-page.model';

@Component({
    selector: 'ms-skeleton-main-mobile',
    templateUrl: './skeleton-main-mobile.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SkeletonMarqueeComponent, SkeletonGridComponent, SkeletonEventsComponent],
})
export class SkeletonMainMobileComponent {
    @Input() pageName: SkeletonPage;
    skeletonPage = SkeletonPage;
}
